import React from "react"
import { View } from "./primitives"

export const Pie = ({ progress = 0, color = "#07c160", size = 40 }: { progress?: number; color?: string; size?: number }) => (
  <View
    style={{
      width: size,
      height: size,
      borderRadius: size / 2,
      background: `conic-gradient(${color} ${progress * 360}deg, #eee 0)`,
    }}
  />
)

export default { Pie }
